<template>
  <div>
    <SliderFull
      v-if="imagens.length && tipo === 1 && show"
      :sliders="[imagens]"
      :is-loading="isLoading"
    />
    <div
      v-if="isHtml && componente.html && componente.html.conteudo && show"
      class="component-html"
      v-html="componente.html.conteudo"
    />
    <loadingSliderFull v-if="!imagens.length && tipo === 1 && show && isLoading" />

    <div class="section-all-components">
      <ParceirosSlider
        v-if="imagens.length && tipo === 2 && show"
        :sliders="imagens"
        :is-loading="isLoading"
      />
      <loadingSliderParceiros v-if="!imagens.length && tipo === 2 && show && isLoading" />

      <BannerTree
        v-if="imagens.length && tipo === 3 && show"
        :data="imagens"
        :show-title="false"
        cols="3"
        rows="1"
        gap="gap-9"
        margin="mt-4 mb-4"
        :login-required="requiresLogin"
        :is-loading="isLoading"
        :rules="[
          { col: 'col-span-1', row: 'row-span-1' },
          { col: 'col-span-1', row: 'row-span-1' },
          { col: 'col-span-1', row: 'row-span-1' },
        ]"
      />
      <loadingBanner v-if="!imagens.length && tipo === 3 && isLoading" />

      <BannerTree
        v-if="imagens.length > 0 && tipo === 4 && show"
        :data="imagens"
        :show-title="false"
        cols="1"
        margin="mt-8 mb-8"
        rows="1"
        :login-required="requiresLogin"
        :rules="[{ col: 'col-span-1', row: 'row-span-1' }]"
      />
      <loadingBanner v-if="!imagens.length && tipo === 4 && isLoading" />

      <CategoriasSlider
        v-if="imagens.length && tipo === 5 && show"
        :data="imagens"
        :titulo="componente.descricao"
      />
      <LoadingCategoriasSlider
        v-if="!imagens.length && tipo === 5 && show && isLoading"
      />

      <ProdutosSlider
        v-if="tipo === 6 && hasProdutos && show"
        :titulo="componente.descricao"
        :produtos="[componente.produtos]"
      />
      <loadingItemProduto
        v-if="show && tipo === 6 && componente.produtos && !hasProdutos && isLoadingProducts"
      />

      <BannerTree
        v-if="imagens.length && tipo === 7 && show"
        :data="imagens"
        :show-title="false"
        cols="2"
        rows="1"
        :login-required="false"
        gap="gap-9"
        margin="mt-8 mb-8"
        :rules="[
          { col: 'col-span-1', row: 'row-span-1' },
          { col: 'col-span-1', row: 'row-span-1' },
        ]"
      />
      <loadingBanner
        v-if="!imagens.length && tipo === 7 && show && isLoading"
      />

      <BannerTree
        v-if="imagens.length && tipo === 12 && show"
        :data="imagens"
        :show-title="false"
        :cols="String(componente.slots || 4)"
        rows="1"
        gap="gap-9"
        margin="mt-4 mb-4"
        :login-required="requiresLogin"
        :is-loading="isLoading"
        :rules="bannerFlexivelRules"
      />
      <loadingBanner v-if="!imagens.length && tipo === 12 && isLoading" />
    </div>

    <PopUpComponent
      v-if="tipo === 10 && imagens.length && show"
      :componente="componente"
    />
  </div>
</template>

<script>
import BannerTree from "@/components/banner/tree";
import SliderFull from "@/components/slider-full/SliderFull";
import loadingSliderFull from "@/components/slider-full/loading/SliderFull";
import ParceirosSlider from "@/components/parceiros-slider/ParceirosSlider";
import loadingSliderParceiros from "@/components/parceiros-slider/loading/Parceiros";
import CategoriasSlider from "@/components/categorias-slider/CategoriasSlider";
import LoadingCategoriasSlider from "@/components/categorias-slider/loading/LoadingCategoriasSlider";
import loadingBanner from "@/components/banners-destaque/loading/Banner";
import ProdutosSlider from "@/components/produtos/ProdutosSlider";
import loadingItemProduto from "@/components/produtos/loading/ItemProduto";
import PopUpComponent from "@/components/componentes/PopUpComponent";

export default {
  name: "ComponentRenderer",
  components: {
    BannerTree,
    SliderFull,
    loadingSliderFull,
    ParceirosSlider,
    loadingSliderParceiros,
    CategoriasSlider,
    LoadingCategoriasSlider,
    loadingBanner,
    ProdutosSlider,
    loadingItemProduto,
    PopUpComponent,
  },
  props: {
    componente: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isLoadingProducts: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tipo() {
      return Number(this.componente.tipo_id);
    },
    imagens() {
      return this.componente.imagens_validas || [];
    },
    isHtml() {
      return this.tipo === 9 || this.tipo === 11;
    },
    hasProdutos() {
      return this.componente.produtos && this.componente.produtos.length > 0;
    },
    bannerFlexivelRules() {
      if (this.tipo !== 12) return [];
      const slots = parseInt(this.componente.slots, 10) || 4;
      return Array.from({ length: slots }, () => ({ col: "col-span-1", row: "row-span-1" }));
    },
    requiresLogin() {
      return (
        this.componente.tipo_visualizacao == 0 ||
        this.componente.tipo_visualizacao == 1
      );
    },
    isAuthenticated() {
      return this.$store.getters.getIsAuthenticated;
    },
    show() {
      const tv = this.componente.tipo_visualizacao;
      if (tv == 0 || !tv) return true;
      if (tv == 1) return this.isAuthenticated;
      if (tv == 2) return !this.isAuthenticated;
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.section-all-components {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}

.component-html {
  width: 100%;
  max-width: 1360px;
  margin: 0 auto;
}
</style>
